/**
 * @param {string | undefined} [className]
 * @returns {React.ReactElement}
 */
const CompanyLogoFMC = ({ className }) => (
  <svg
    width="290"
    height="62"
    className={className}
    viewBox="0 0 290 62"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.7263 6.84604L0 0L8.29239 13.4028L39.7263 20.2489L71.1603 13.4028L79.4526 0L39.7263 6.84604Z"
      fill="currentColor"
    />
    <path
      d="M39.7264 62L48.3081 48.3079L39.7264 50.6221L31.2412 48.3079L39.7264 62Z"
      fill="currentColor"
    />
    <path
      d="M15.6205 25.5521L39.7263 30.5661L63.9285 25.5521L56.2146 37.7014L39.7263 41.944L23.2379 37.7014L15.6205 25.5521Z"
      fill="currentColor"
    />
    <path
      d="M271.577 59.7823H286.041V55.5397H276.302V51.7792H282.377V47.633H276.302V44.8368H285.366V40.5941H271.577V59.7823Z"
      fill="currentColor"
    />
    <path
      d="M104.38 59.7823V50.0436L99.5585 60.3609L94.8337 50.0436V59.7823H90.2054V40.6906H94.7373L99.6549 51.3935L104.476 40.6906H109.008V59.7823H104.38Z"
      fill="currentColor"
    />
    <path
      d="M135.717 59.7823H129.642V40.6906H136.103C141.888 40.6906 145.841 43.1011 145.841 50.14C145.938 57.1789 141.888 59.7823 135.717 59.7823ZM136.103 44.9332H134.56V55.5397H135.91C139.477 55.5397 140.924 53.9005 140.924 50.2364C140.924 46.5724 139.67 44.9332 136.103 44.9332Z"
      fill="currentColor"
    />
    <path
      d="M153.459 40.6906H148.541V59.7823H153.459V40.6906Z"
      fill="currentColor"
    />
    <path
      d="M167.922 47.3438L172.358 45.5117C171.104 42.3298 169.079 40.3049 164.837 40.3049C159.726 40.3049 156.159 44.1618 156.159 50.14C156.159 55.9254 159.341 59.9752 164.74 59.9752C168.887 59.9752 171.104 57.8539 172.454 55.2505L168.404 53.0327C167.344 54.7683 166.572 55.6361 164.837 55.6361C162.33 55.6361 161.173 53.2256 161.173 50.14C161.173 46.9581 162.33 44.6439 164.74 44.6439C166.476 44.6439 167.247 45.7046 167.922 47.3438Z"
      fill="currentColor"
    />
    <path
      d="M186.05 59.7823L184.893 56.1182H178.625L177.468 59.7823H172.454L179.493 40.6906H184.314L191.353 59.7823H186.05ZM179.975 52.0685H183.736L181.904 45.8974L179.975 52.0685Z"
      fill="currentColor"
    />
    <path
      d="M193.185 59.7823H206.877V55.4433H198.006V40.6906H193.185V59.7823Z"
      fill="currentColor"
    />
    <path
      d="M227.608 47.3438L232.044 45.5117C230.79 42.3298 228.765 40.3049 224.523 40.3049C219.412 40.3049 215.845 44.1618 215.845 50.14C215.845 55.9254 219.027 59.9752 224.426 59.9752C228.572 59.9752 230.79 57.8539 232.14 55.2505L228.09 53.0327C227.03 54.7683 226.258 55.6361 224.523 55.6361C222.016 55.6361 220.859 53.2256 220.859 50.14C220.859 46.9581 222.016 44.6439 224.426 44.6439C226.162 44.6439 226.933 45.7046 227.608 47.3438Z"
      fill="currentColor"
    />
    <path
      d="M245.736 59.7823L244.579 56.1182H238.311L237.154 59.7823H232.044L239.083 40.6906H243.904L250.943 59.7823H245.736ZM239.565 52.0685H243.325L241.397 45.8974L239.565 52.0685Z"
      fill="currentColor"
    />
    <path
      d="M263.574 59.7823L260.392 53.2256H257.692V59.7823H252.968V40.6906H261.646C265.792 40.6906 268.781 42.5226 268.781 46.8616C268.781 49.7543 267.431 51.4899 265.31 52.4542L269.07 59.7823H263.574ZM261.356 44.7403H257.596V49.1758H261.356C263.092 49.1758 263.863 48.4044 263.863 46.8616C263.863 45.5117 263.092 44.7403 261.356 44.7403Z"
      fill="currentColor"
    />
    <path
      d="M112.672 59.7823H127.135V55.5397H117.493V51.7792H123.568V47.633H117.493V44.8368H126.461V40.5941H112.672V59.7823Z"
      fill="currentColor"
    />
    <path
      d="M228.248 31.3375C233.069 31.3375 236.058 29.3126 236.058 25.1664C236.058 21.4059 233.551 20.056 229.308 19.0918C226.705 18.4168 225.933 18.1275 225.933 17.2597C225.933 16.4883 226.415 15.9098 228.151 15.9098C230.08 15.9098 231.622 16.5848 233.165 17.6454L235.769 14.0778C233.84 12.535 231.526 11.5708 228.344 11.5708C224.005 11.5708 221.016 13.8849 221.016 17.4526C221.016 21.2131 223.33 22.4666 227.573 23.4308C230.465 24.1058 231.14 24.5879 231.14 25.4557C231.14 26.5163 230.369 26.9985 228.344 26.9985C226.512 26.9985 224.294 26.1307 222.944 25.07L220.341 28.6377C222.173 30.2769 225.066 31.3375 228.248 31.3375Z"
      fill="currentColor"
    />
    <path
      d="M95.0266 16.1991V19.1882H101.776V23.4308H95.0266V31.0482H90.2054V11.9565H104.476V16.1991H95.0266Z"
      fill="currentColor"
    />
    <path
      d="M117.011 31.0482L113.829 24.4915H111.129V31.0482H106.405V11.9565H115.083C119.229 11.9565 122.218 13.7885 122.218 18.1275C122.218 21.0202 120.868 22.7558 118.65 23.7201L122.411 31.0482H117.011ZM114.89 16.1026H111.129V20.5381H114.89C116.625 20.5381 117.397 19.7667 117.397 18.224C117.397 16.874 116.625 16.1026 114.89 16.1026Z"
      fill="currentColor"
    />
    <path
      d="M124.918 31.0482H139.381V26.902H129.739V23.1415H135.814V18.9953H129.739V16.1991H138.803V11.9565H124.918V31.0482Z"
      fill="currentColor"
    />
    <path
      d="M148.252 31.3375C153.073 31.3375 156.062 29.3126 156.062 25.1664C156.062 21.4059 153.555 20.056 149.313 19.0918C146.613 18.4168 145.938 18.1275 145.938 17.2597C145.938 16.4883 146.42 15.9098 148.156 15.9098C150.084 15.9098 151.627 16.5848 153.17 17.6454L155.773 14.0778C153.845 12.535 151.53 11.5708 148.348 11.5708C144.009 11.5708 141.02 13.8849 141.02 17.4526C141.02 21.2131 143.334 22.4666 147.577 23.4308C150.47 24.1058 151.145 24.5879 151.145 25.4557C151.145 26.5163 150.373 26.9985 148.348 26.9985C146.516 26.9985 144.299 26.1307 142.949 25.07L140.345 28.6377C142.177 30.2769 145.07 31.3375 148.252 31.3375Z"
      fill="currentColor"
    />
    <path
      d="M158.569 31.0482H173.033V26.902H163.39V23.1415H169.465V18.9953H163.39V16.1991H172.358V11.9565H158.569V31.0482Z"
      fill="currentColor"
    />
    <path
      d="M187.689 31.0482H191.739V11.9565H187.111V22.3701L179.686 11.9565H175.347V31.0482H179.975V20.1524L187.689 31.0482Z"
      fill="currentColor"
    />
    <path
      d="M200.128 11.9565H195.21V31.0482H200.128V11.9565Z"
      fill="currentColor"
    />
    <path
      d="M211.409 31.3375C216.231 31.3375 219.605 28.6376 219.605 22.7558V11.9565H214.784V22.8523C214.784 25.4557 213.724 26.9985 211.506 26.9985C209.288 26.9985 208.227 25.3593 208.227 22.8523V11.9565H203.31V22.8523C203.31 28.7341 206.685 31.3375 211.409 31.3375Z"
      fill="currentColor"
    />
  </svg>
);

export default CompanyLogoFMC;
